export const NUMBER = {
  FIRST_PAGE: 1,
  PRODUCTS_PER_PAGE: 12,
  PRODUCTS_PER_DESKTOP_PAGE: 999,
  PRODUCTS_PER_MOBILE_PAGE: 6,
  ARTICLES_PER_DESKTOP_PAGE: 10,
  ARTICLES_PER_MOBILE_PAGE: 5,
};
